import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                item: 'enter',
                sub: 'subnavEnter'
            },
            mouseleave: {
                item: 'leave',
                sub: 'subnavLeave'
            },
            click: {
                background: 'close',
                close: 'close',
                item: 'click',
                subnavBackground: 'closeSubnav',
                subnavBack: 'closeSubnav'
            },
        }

        this.oldSubnav = null;
    }

    init() {
        this.bindkeydown = this.keydown.bind(this);
        window.addEventListener('keydown',this.bindkeydown);
    }

    keydown(e) {
        if(e.key == 'Escape') {
            this.close();
        }
    }

    enter(e) {
        if(window.isMobile) return;
        this.openSubnav(e);    
    }

    leave() {
        if(window.isMobile) return;
        this.closeSubnav();
    }

    click(e) {
        if(!window.isMobile) return;
        this.openSubnav(e);
    }

    subnavEnter(e) {

        if(this.oldSubnav != null) {
            this.oldSubnav.classList.remove('is-active');
        }

        html.classList.add('has-subnav-open');

        let el = e.currentTarget;
        el.classList.add('is-active');

        let subnavId = el.getAttribute('data-subnav');
        let menuItem = document.querySelector(`[data-subnav-id=${subnavId}]`);

        this.$('item').forEach(item => {
            item.classList.remove('is-active');
        });
        
        menuItem.classList.add('is-active');

        gsap.delayedCall(1, () => {
            console.log(menuItem);
        })

        this.oldSubnav = el;
    }

    subnavLeave(e) {

        html.classList.remove('has-subnav-open');

        this.$('item').forEach(menuItem => {
            menuItem.classList.remove('is-active');
        });

        if(this.oldSubnav != null) {
            this.oldSubnav.classList.remove('is-active');
        }
    }

    openSubnav(e) {

        if(this.oldSubnav != null) {
            this.oldSubnav.classList.remove('is-active');
        }

        html.classList.add('has-subnav-open');

        let el = e.currentTarget;
        let subnavId = el.getAttribute('data-subnav-id');
        let subnavToOpen = document.querySelector(`[data-subnav=${subnavId}]`);

        this.$('item').forEach(menuItem => {
            menuItem.classList.remove('is-active');
        });

        el.classList.add('is-active');

        subnavToOpen.classList.add('is-active');
        this.oldSubnav = subnavToOpen;
    }

    closeSubnav() {

        html.classList.remove('has-subnav-open');

        this.$('item').forEach(menuItem => {
            menuItem.classList.remove('is-active');
        });

        if(this.oldSubnav != null) {
            this.oldSubnav.classList.remove('is-active');
        }
    }

    open() {
        html.classList.add('has-nav-open');
        gsap.delayedCall(1, () => {
            html.classList.add('has-nav-open-callback');
        });
    }

    close() {
        this.closeSubnav();

        html.classList.remove('has-nav-open');
        html.classList.remove('has-nav-open-callback');
        html.classList.add('has-nav-closing');

        gsap.delayedCall(1, () => {
            html.classList.add('has-nav-closing');
        });

    }

    destroy() {
        window.removeEventListener('keydown',this.bindkeydown);
    }
}
